import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ZoneResponse } from '@key-telematics/fleet-api-client';
import { TranslateService } from '@ngx-translate/core';
import { ErrorLoggerService, NotificationService } from 'app/services';
import { MapComponent, MapControls, MapZonesService } from 'app/shared/components';
import { BaseComponent } from 'app/shared/components/base/base.component';
import { ListSectionHandler } from '../../entities/shared/list.section';

@Component({
    selector: 'key-admin-zone-editor',
    templateUrl: './zone-editor.component.html',
    styleUrls: ['./zone-editor.component.scss'],
    providers: [MapZonesService],
    standalone: false
})
export class AdminZoneEditorComponent extends BaseComponent implements OnChanges, OnDestroy, AfterViewInit {

    @Input() entity: ZoneResponse;
    @Input() handler: ListSectionHandler;
    @Input() editable: boolean;

    @Output() onEditing = new EventEmitter<boolean>();
    @Output() onSaving = new EventEmitter<any>();
    @Output() onSaved = new EventEmitter<any>();

    @ViewChild('map', { static: true }) map: MapComponent;

    mapControls = [
        MapControls.fullscreen,
        MapControls.simplezoneedit,
        MapControls.layers,
    ];

    errorMessage: string;
    private mapReady = false;

    constructor(
        private error: ErrorLoggerService,
        private notify: NotificationService,
        public i18n: TranslateService,
        public zonesService: MapZonesService,
        private ref: ChangeDetectorRef
    ) {
        super();
    }

    ngOnDestroy() {
        this.zonesService.detachMap();
    }

    ngAfterViewInit() {
        this.zonesService.attachMapAndZone(this.map, this.entity);
        this.mapReady = true;

        // update other editors when changes was made to the map
        this.on(this.map.onZonesEdited, e => {
            const zone = {
                ...this.entity,
                ...e.zones.find(x => x.id === this.entity.id),
            };
            this.onSaved.emit(zone);
        });

        // allow the DOM to fully lay out before zooming
        setTimeout(() => {
            this.map.invalidate();
            if (this.entity && this.entity.bounds) {
                this.map.zoomToBounds(this.entity.bounds);
            }
        }, 300);
    }


    ngOnChanges(changes: SimpleChanges) {
        if (changes.entity && this.entity && this.mapReady) {
            this.zonesService.attachMapAndZone(this.map, this.entity);
            this.load().catch(err => this.showError(err));
        } else if (changes.handler && this.handler) {
            this.load().catch(err => this.showError(err));
        }
    }

    async load(): Promise<void> {
        this.errorMessage = null;
        if (this.entity && this.mapReady) {
            setTimeout(() => {
                this.map.invalidate();
                this.map.zoomToBounds(this.entity.bounds);
            }, 100);
        }
        this.ref.markForCheck();
    }

    showError(error: any) {
        this.error.trackException(error);
        this.errorMessage = error && this.notify.translateError(error);
        this.ref.markForCheck();
    }



}
